const commonExplortOtherLinks = [
    {
        url: '/flights',
        key: 'domesticFlights'
    },
    {
        url: '/international-flights',
        key: 'internationalFlights'
    },
    {
        url: '/flight-booking/domestic-airlines.html',
        key: 'domesticAirlines'
    },
    {
        url: '/flight-booking/international-airlines.html',
        key: 'internationalAirlines'
    },
    {
        url: '/flight-schedule/flight-schedules-domestic.html',
        key: 'domesticFlightSchedule'
    },
    {
        url: '/flight-schedule/flight-schedules-international.html',
        key: 'internationalFlightSchedule'
    },
    {
        url: '/flight-schedule/india-dubai-flights.html',
        key: 'indiaToDubaiFlights'
    },
    {
        url: '/flight-schedule/dubai-india-flights.html',
        key: 'dubaiToIndiaFlights'
    }
]

export const exploreOtherLinksByDomain = {
    AE: commonExplortOtherLinks,
    SA: commonExplortOtherLinks,
    KW: commonExplortOtherLinks,
    BH: commonExplortOtherLinks,
    OM: commonExplortOtherLinks,
    QA: commonExplortOtherLinks,
}

export default exploreOtherLinksByDomain;